import { Link } from "react-router-dom";
import Top from "./Top";
import Footer from "./Footer";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState, useRef } from "react";

function Dashboard() {
  const user = JSON.parse(localStorage.getItem("SLNUserDetails") || "{}");

  const scrollRef = useRef(null);
  const scroll = (ref, direction) =>
    ref.current.scrollBy({ left: direction * 350, behavior: "smooth" });

  const formatDate = (isoString) => {
    const date = new Date(isoString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${day}/${month}/${year} ${String(hours).padStart(2, "0")}:${minutes} ${ampm}`;
  };

  const [userDetails, setUserDetails] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("SLNToken");
    const stored = localStorage.getItem("SLNUserDetails");

    if (stored) {
      try {
        setUserDetails(JSON.parse(stored));
      } catch {
        setUserDetails(null);
      }
    }

    if (!token) return;

    try {
      const decoded = JSON.parse(atob(token.split(".")[1]));
      const userId = decoded.userId || decoded.id || decoded.sub;

      fetch(
        `https://522gqh3w18.execute-api.ap-south-1.amazonaws.com/Prod/Profile/GetUserProfile?userId=${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      )
        .then((res) => res.json())
        .then((data) => {
          localStorage.setItem("SLNUserDetails", JSON.stringify(data));
          setUserDetails(data);
        })
        .catch((err) => console.error("User fetch error:", err));
    } catch (err) {
      console.error("Token decode error:", err);
    }
  }, []);

  return (
    <>
      <Top />

      <section>
        <div className="container mt-5">
          <div className="row">
            <div className="col-12 d-flex align-items-center">
              <div className="d-flex align-items-center">
                <div className="me-4">
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/727/727399.png"
                    width="70"
                  />
                </div>
                <div>
                  <h1 className="h2 fw-medium ls-sm m-0 lh-1 mt-3">
                    Welcome, {user.name} [{user.userId}] 👋
                  </h1>
                  {user.phone && (
                    <p className="m-0 fs-4 lh-sm mt-2">(+91) {user.phone}</p>
                  )}
                  {user.email && <p className="m-0 fs-4 lh-sm">{user.email}</p>}
                  {user.createdAt && (
                    <p className="m-0 fs-4 lh-sm">
                      Joined On &mdash; {formatDate(user.createdAt)}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container mt-7">
          <div className="row text-center">
            <div className="col-md-12 px-lg-8">
              <span className="text-uppercase text-primary fw-semibold ls-sm fs-3 lh-1">
                Our Internship Partners
              </span>
              <h2 className="h1 fw-normal ls-sm text-dark lh-1 mt-1">
                Organizations Empowering Our Internship Programs
              </h2>
              <div className="mt-n2 pt-2">
                <img
                  src="/assets/images/line-shap.webp"
                  width="230"
                  className="mt-2"
                />
              </div>
            </div>
            
            <div className="position-relative mt-4 mb-2">
              <button
                onClick={() => scroll(scrollRef, -1)}
                className="position-absolute top-50 start-0 translate-middle-y z-1 btn btn-light rounded-circle shadow d-flex align-items-center justify-content-center"
                style={{ width: 44, height: 44 }}
              >
                <i className="bi bi-chevron-left"></i>
              </button>

              <div
                ref={scrollRef}
                className="d-flex gap-2 overflow-x-scroll"
                style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
              >
                <img
                  src="/assets/images/internship/1.jpeg"
                  className="object-fit-cover rounded-5 border border-light"
                  width="350"
                  height="350"
                />
                <img
                  src="/assets/images/internship/2.jpeg"
                  className="object-fit-cover rounded-5 border border-light"
                  width="290"
                  height="350"
                />
                <img
                  src="/assets/images/internship/5.jpeg"
                  className="object-fit-cover rounded-5 border border-light"
                  width="420"
                  height="350"
                />
                <img
                  src="/assets/images/internship/6.jpeg"
                  className="object-fit-cover rounded-5 border border-light"
                  width="450"
                  height="350"
                />
                <img
                  src="/assets/images/internship/3.jpeg"
                  className="object-fit-cover rounded-5 border border-light"
                  width="400"
                  height="350"
                />
                <img
                  src="/assets/images/internship/4.jpeg"
                  className="object-fit-cover rounded-5 border border-light"
                  width="400"
                  height="350"
                />
              </div>

              <button
                onClick={() => scroll(scrollRef, 1)}
                className="position-absolute top-50 end-0 translate-middle-y z-1 btn btn-light rounded-circle shadow d-flex align-items-center justify-content-center"
                style={{ width: 44, height: 44 }}
              >
                <i className="bi bi-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="pt-7 overflow-hidden">
          <div className="row justify-content-center">
            <div>
              <span className="text-primary d-block text-uppercase fw-semibold ls-xl text-center">
                Trusted by top companies in India
              </span>

              <div className="d-flex gap-1 justify-content-center mt-3 mb-4">
                {[1, 2, 3].map((num) => (
                  <img
                    key={num}
                    src={`/assets/images/partners/${num}.png`}
                    className="marquee-image-partners bg-dark-soft px-5 py-3 rounded-4 opacity-100"
                    width="40"
                    alt=""
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div className="container mt-5">
          <div className="bg-success p-lg-6 p-5 rounded-top-5">
            <div className="container">
              <div className="row">
                <div className="col-lg-8">
                  <h5 class="mb-0 fs-3 fw-normal lh-sm text-light">
                    Free 7-Day Masterclass — Intraday & Option Chain Data
                    Trading
                  </h5>
                  <h2 class="h1 text-white fw-normal ls-sm lh-1">
                    Trusted By <span className="fw-bold">10K+</span> Users
                  </h2>
                  <div className="mt-n4 pt-2">
                    <img
                      src="/assets/images/line-shap.webp"
                      width="230"
                      className="mt-2"
                    />
                  </div>
                </div>
                <div className="col-lg-4 d-flex justify-content-lg-end justify-content-center align-items-center">
                  <a
                    href="https://www.youtube.com/@SLNAcademyOfficial"
                    target="_blank"
                    className="btn btn-light btn-md px-7 rounded-4 mb-lg-0 mb-5"
                  >
                    Subscribe Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Dashboard;
